import React from 'react';
import { X, Check } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function Transformacion() {
  const antes = ['Errores constantes', 'Mala ubicación', 'Falta de confianza'];
  const despues = ['Más puntos ganados', 'Mejor lectura del juego', 'Mayor seguridad en la cancha', 'Mejor compañero de dobles', 'Más victorias'];
  return <section className="py-14 bg-padel-dark relative border-t border-white/5" data-id="element-265">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-266">
        <FadeIn data-id="element-267">
          <h2 className="font-display text-2xl md:text-3xl font-bold text-center mb-8 uppercase" data-id="element-268">
            Imaginá cómo podrías jugar{' '}
            <span className="text-neon" data-id="element-269">dentro de 30 días</span>
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-5" data-id="element-270">
          {/* ANTES */}
          <FadeIn direction="right" data-id="element-271">
            <div className="bg-red-950/20 border border-red-900/50 rounded-xl p-5 h-full" data-id="element-272">
              <h3 className="font-display text-lg font-bold text-red-500 mb-4 uppercase text-center" data-id="element-273">
                Antes
              </h3>
              <ul className="space-y-3" data-id="element-274">
                {antes.map((item, idx) => <li key={idx} className="flex items-center gap-3 text-gray-300 text-sm" data-id="element-275">
                    <div className="bg-red-500/20 p-1.5 rounded-full flex-shrink-0" data-id="element-276">
                      <X className="w-4 h-4 text-red-500" data-id="element-277" />
                    </div>
                    {item}
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* DESPUÉS */}
          <FadeIn direction="left" delay={0.2} data-id="element-278">
            <div className="bg-neon/5 border border-neon/30 rounded-xl p-5 h-full relative overflow-hidden shadow-[0_0_30px_rgba(198,255,0,0.05)]" data-id="element-279">
              <div className="absolute top-0 right-0 w-48 h-48 bg-neon/10 blur-[80px] rounded-full pointer-events-none" data-id="element-280"></div>
              <h3 className="font-display text-lg font-bold text-neon mb-4 uppercase text-center relative z-10" data-id="element-281">
                Después
              </h3>
              <ul className="space-y-3 relative z-10" data-id="element-282">
                {despues.map((item, idx) => <li key={idx} className="flex items-center gap-3 text-white font-medium text-sm" data-id="element-283">
                    <div className="bg-neon/20 p-1.5 rounded-full flex-shrink-0" data-id="element-284">
                      <Check className="w-4 h-4 text-neon" data-id="element-285" />
                    </div>
                    {item}
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}